import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Typography from '../../../Pdf/components/Typography';
import FirmLogo from '../../../Pdf/components/FirmLogo';
import Column from '../../../Pdf/components/Column';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';
import Divider from './Divider';

const styles = StyleSheet.create({
  container: {
    marginBottom: theme.spacing(theme.spacingSizes.md),
    gap: theme.spacing(theme.spacingSizes.xxs * 3),
  },
});

type Props = {
  firmLogoUrl: string;
  header?: string;
};

const Header: FC<Props> = ({ firmLogoUrl, header }) => {
  return (
    <Column style={styles.container}>
      <Row spacing="sm" justify="space-between" centered>
        <FirmLogo url={firmLogoUrl} />
        {header ? (
          <Typography variant="body2" color={theme.palette.grey[500]}>
            {header}
          </Typography>
        ) : null}
      </Row>
      <Divider />
    </Column>
  );
};

export default Header;
